import type { FC } from "react";
import { InputValidationResult } from "../../types";
import { cn, inputSurface } from "@design-system";

interface SelectProps {
  id: string;
  defaultValue?: string;
  emptyOption?: boolean | false;
  emptyOptionLabel?: string;
  options: Array<SelectOpionProp>;
  validation?: InputValidationResult;
  onSelectChanged?: (input: string) => void;
  disabled?: boolean;
  className?: string;
}

interface SelectOpionProp {
  key: string;
  value?: string;
  label: string;
}

export const StyledSelect: FC<SelectProps> = function (props: SelectProps) {
  return (
    <select
      className={cn(
        "w-full relative disabled:opacity-50",
        inputSurface,
        props.className,
      )}
      id={props.id}
      name={props.id}
      defaultValue={props.defaultValue ?? props.options[0]?.key}
      disabled={props.disabled}
      color={
        props.validation?.show &&
        (props.validation?.isMissing || props.validation?.isInvalid)
          ? "failure"
          : ""
      }
      //helperText={props.validation?.show ? getValidationMessage() : ""}
      onChange={(e) =>
        props.onSelectChanged ? props.onSelectChanged(e.target.value) : null
      }
    >
      {props.emptyOption ? (
        <option value="">{props.emptyOptionLabel ?? " "}</option>
      ) : null}
      {props.options.map((option) => (
        <option key={option.key} value={option.value ?? option.key}>
          {option.label}
        </option>
      ))}
    </select>
  );
};
